<template>
    <div></div>
</template>

<script>
    export default {
        name: "EditUser"
    }
</script>

<style scoped>

</style>